/* ap-wb-upgrade.js (Apollo, Nathan 19 Oct 17:00): Starter Bundle "Upgrade to AutoShip & Save 50%" in cart.
   Removes the one-time Starter Bundle line and adds its pouches on AutoShip:
   30 Sticks -> 30-day plan, 60 Sticks -> 60-day plan. BOGOS then adds the gifts for those pouches. */
(function () {
  if (window.__apWbUpgradeBound) return; window.__apWbUpgradeBound = true;
  var PLAN30 = 116897120555, PLAN60 = 118651191595;
  var VARIETY = 47821942358315, BC = 55652736008491, RASP = 53361822368043;
  var MAP = {
    'variety-welcome-bundle-30-days': { plan: PLAN30, items: [[VARIETY, 2]] },
    'variety-welcome-bundle-60-days': { plan: PLAN60, items: [[VARIETY, 4]] },
    'hyro-perform-welcome-bundle-30-sticks': { plan: PLAN30, items: [[BC, 1], [RASP, 1]] },
    'hyro-perform-welcome-bundle-60-sticks': { plan: PLAN60, items: [[BC, 2], [RASP, 2]] }
  };
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(path, body) {
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.status && j.description) throw new Error(j.description); return j; });
  }
  function overlay(on) {
    var d = document.querySelector('nss-slidecart'); if (!d) return;
    var ex = d.querySelector('.nss-cart-loading-overlay'); if (ex) ex.remove();
    if (!on) return;
    var o = document.createElement('div'); o.className = 'nss-cart-loading-overlay'; o.innerHTML = '<div class="nss-cart-loader"></div>';
    var inner = d.querySelector('.nss-slidecart__inner-wrapper') || d.querySelector('.nss-slidecart__inner') || d;
    inner.style.position = 'relative'; inner.appendChild(o);
  }
  function refresh() {
    var h = document.querySelector('[nss-cart-handler]');
    var sid = h && h.getAttribute('nss-parent-section-id');
    if (!h || !sid) { location.reload(); return Promise.resolve(); }
    return post('cart/update.js', { updates: {}, sections: sid, sections_url: location.pathname + location.search }).then(function (cart) {
      var html = cart.sections && cart.sections[sid]; if (!html) { location.reload(); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cur = h.querySelector('[nss-cart-product-list]'), nxt = doc.querySelector('[nss-cart-product-list]');
      if (cur && nxt) cur.replaceWith(nxt);
      h.querySelectorAll('[nss-cart-reload]').forEach(function (c) {
        var r = doc.querySelector('[nss-cart-reload="' + c.getAttribute('nss-cart-reload') + '"]');
        if (r) c.replaceWith(r); else c.remove();
      });
      var n = nxt && nxt.getAttribute('nss-cart-item-count');
      if (n != null) document.querySelectorAll('[nss-cart-count],[nss-cart-badge-count]').forEach(function (x) { x.innerHTML = n; });
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'ap-wb-upgrade' } })); } catch (e) {}
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[ap-wb-upgrade]') : null;
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.dataset.busy === '1') return; btn.dataset.busy = '1';
    var key = btn.getAttribute('data-line-key');
    overlay(true);
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (l) { return l.key === key; })[0];
      var cfg = line && MAP[line.handle];
      if (!cfg || line.selling_plan_allocation) return null;
      var add = cfg.items.map(function (it) { return { id: it[0], quantity: it[1] * line.quantity, selling_plan: cfg.plan }; });
      var upd = {}; upd[key] = 0;
      /* Add the AutoShip pouches first; only remove the bundle once that succeeded, so a failed add never empties the cart. */
      return post('cart/add.js', { items: add }).then(function () { return post('cart/update.js', { updates: upd }); });
    }).then(function () {
      return new Promise(function (r) { setTimeout(r, 1200); });
    }).then(refresh).then(function () {
      setTimeout(function () { refresh().catch(function () {}); }, 2500);
      overlay(false);
    }).catch(function (err) {
      try { console.error('[ap-wb-upgrade]', err); } catch (x) {}
      delete btn.dataset.busy; overlay(false); refresh().catch(function () { location.reload(); });
    });
  }, true);
})();
